import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import * as React from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import { getDomainState } from '../actions/getDomainState';
import { startDomainEnroll } from '../actions/startDomainEnroll';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { OptionDescription } from 'owa-options-controls';
var styles = require('./DomainEnrollOptionFull.scss');
var DomainEnrollOptionFull = /** @class */ (function (_super) {
    tslib_1.__extends(DomainEnrollOptionFull, _super);
    function DomainEnrollOptionFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DomainEnrollOptionFull.prototype.componentDidMount = function () {
        getDomainState();
    };
    DomainEnrollOptionFull.prototype.render = function () {
        return (React.createElement("div", { className: styles.enrollDomain_container },
            React.createElement("div", null,
                React.createElement(OptionDescription, null, strings.options_premiumSubOption_EnrollDomain),
                React.createElement(Link, { href: "https://go.microsoft.com/fwlink/?linkid=871933", target: "_blank" }, strings.options_premium_AdvancedSecurityContent_LearnMore)),
            React.createElement("div", { className: styles.domain_btn_container },
                React.createElement(PrimaryButton, { text: strings.options_premiumSubOption_GetStarted, "data-is-focusable": true, disabled: false, onClick: startDomainEnroll }))));
    };
    DomainEnrollOptionFull = tslib_1.__decorate([
        observer
    ], DomainEnrollOptionFull);
    return DomainEnrollOptionFull;
}(React.Component));
export default DomainEnrollOptionFull;
//# sourceMappingURL=DomainEnrollOptionFull.js.map